import './_toggle-next.js';

function getCssVar(name) {
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}
  
function isMobileViewport() {
    const bp = getCssVar('--breakpoints-tablet');
    return window.matchMedia(`(max-width: ${bp})`).matches;
}

/**
 * Header
 */
document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.dg-header');
  
    if (!header) return;
  
    const handleScroll = () => {
      if (window.scrollY > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
  
    window.addEventListener('scroll', handleScroll);
  });
  
  document.addEventListener('DOMContentLoaded', () => {

    let overlay = document.getElementById('menu-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'menu-overlay';
      overlay.className = 'menu-overlay';
      document.body.appendChild(overlay);
    }
  
    const style = document.createElement('style');
    style.textContent = `
      .menu-overlay {
        position: fixed;
        inset: 0;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 963;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition: opacity 0.3s ease, visibility 0.3s ease;
      }
      .menu-overlay.is-active {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
      }
    `;
    document.head.appendChild(style);
  
    const observer = new MutationObserver(() => {
      const hasActiveMenu = document.querySelector('.e-n-menu-content.e-active') !== null;
      overlay.classList.toggle('is-active', hasActiveMenu);
    });
  
    const menus = document.querySelectorAll('.e-n-menu-content');
    menus.forEach(menu => {
      observer.observe(menu, { attributes: true, attributeFilter: ['class'] });
    });
  
    // Si tu veux fermer les menus en cliquant sur l'overlay
    overlay.addEventListener('click', () => {
      document.querySelectorAll('.e-n-menu-content.e-active').forEach(menu => {
        menu.classList.remove('e-active');
      });
    });
  });

/**
 * Quote Card Read More Toggle
 */
document.addEventListener('DOMContentLoaded', function() {
    const quoteCards = document.querySelectorAll('.quote-card');
    
    quoteCards.forEach(card => {
        const readMoreBtn = card.querySelector('.quote-card__read-more--toggle');
        
        if (!readMoreBtn) return;
        
        // Click to expand
        readMoreBtn.addEventListener('click', function() {
            card.classList.add('is-expanded');
            
            // Add animation-complete class after animation duration (400ms)
            setTimeout(() => {
                card.classList.add('animation-complete');
            }, 400);
        });
        
        // Hover outside card to collapse
        card.addEventListener('mouseleave', function() {
            card.classList.remove('is-expanded');
            card.classList.remove('animation-complete');
        });
    });
});
